import { Injectable,   } from '@angular/core';
import { tap } from 'rxjs';
import { BaseService } from './base.service';

import { TranslateService as NgxTranslateService } from '@ngx-translate/core';
import { LocalStorage } from '../helpers/localstorage.helper';

@Injectable({
  providedIn: 'root'
})
export class TranslationService extends BaseService {
  currentLang: 'ar' | 'en' = 'ar';
  private _Localization = {};

  constructor( private ngxTranslateService: NgxTranslateService) {
      super('/V1')
  }

    loadLocalization() {
        return super.request('Localization', {},"Get").pipe(tap((res: any) => {
          this._Localization = { ar: res.ar, en: res.en };
          this.ngxTranslateService.addLangs(['en', 'ar']);
          this.ngxTranslateService.setDefaultLang('ar');
          this.ngxTranslateService.use('ar');
          this.ngxTranslateService.store.translations = this.localization;
          this.ngxTranslateService['changeDefaultLang']()
          return res;
    }))
  }

  setLang(val : any) {
    const value = val || 'ar';
    this.ngxTranslateService.use(value);
    LocalStorage.set('lang', value)
    document.documentElement.setAttribute('lang', value);
    this.currentLang = value;
  }
  switchLang() {
    if (this.currentLang == 'ar') {
      this.setLang('en')
      LocalStorage.set('LanguagePrefrences', 'en-SA')
    } else {
      this.setLang('ar')
      LocalStorage.set('LanguagePrefrences', 'ar-SA')
    }
  }
  public get localization(): any {
    return this._Localization;
  }

}
